import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { XCircle } from 'lucide-react';

const PaymentCancelled = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-b from-purple-600 to-purple-800 flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8 text-center" data-testid="payment-cancelled-card">
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 bg-amber-100 rounded-full flex items-center justify-center">
            <XCircle className="h-12 w-12 text-amber-600" />
          </div>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2" data-testid="payment-cancelled-title">
          {t('paymentCancelledTitle')}
        </h1>
        <p className="text-gray-600 mb-6">{t('paymentCancelledDesc')}</p>
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-6 text-left">
          <p className="text-sm text-amber-800">{t('paymentCancelledNote')}</p>
        </div>
        <div className="space-y-3">
          <button
            onClick={() => navigate('/signin')}
            className="w-full py-3 bg-purple-600 text-white font-semibold rounded-lg hover:bg-purple-700 transition-colors"
            data-testid="cancelled-signin-btn"
          >
            {t('signInToCompletePayment')}
          </button>
          <button
            onClick={() => navigate('/')}
            className="w-full py-3 bg-gray-100 text-gray-700 font-semibold rounded-lg hover:bg-gray-200 transition-colors"
            data-testid="cancelled-home-btn"
          >
            {t('goHome')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelled;
